import { FC } from "react";
import { APP_NAME } from "../../config/constants";
import "./Footer.scss";

interface Props {}

export const Footer: FC<Props> = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <h2 className="footer-title">{APP_NAME}</h2>
          <p className="footer-copyright">
            © 2025 媲美科技(长沙)有限公司,保留所有权利
          </p>
        </div>
        <div className="footer-right">
          <a href="mailto:contact@shanzhiyin.com" className="footer-email">
            <i className="iconfont icon-youxiang"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}; 